import { storageService, cacheService, Logger, oktaService, siteConfigService, URLUtils, WindowUtils, featureService } from '@ol/ol-ui-core';
import store from '@/store';
import { LOGOUT_TYPE } from '@/entities/site.configuration';
import storageServiceIQUI from '@/services/storage.service';


class ClearLocalStorageRedirectToLogoutService {
  public getLogOutType(): LOGOUT_TYPE {
    const hash = window.location.hash;
    if (hash.startsWith('#/clearLocalStorageRedirectToLogoutPage?redirectToLogoutUrl=')) {
      return LOGOUT_TYPE.CLASSIC;
    } else if (hash.startsWith('#/oktaProxy')) {
      return LOGOUT_TYPE.OKTA;
    }
    return null;
  }


  public async clearLocalStorageAndClassicLogout():Promise<void> {
    localStorage.setItem('isDoingSingleSignOut', `${true}`);
    const plId = await storageServiceIQUI.getPrivateLabelId();
    const isMFAEnabled = await featureService.isFeatureEnabled(plId, 'OKTA_MFA');
    let url = this.getLogoutRedirectUrl();
    if (isMFAEnabled && !!url) {
      const oktaLogoutUrl = await siteConfigService.getApiEndpoint(plId, 'auth.okta.oktaLogoutProxyPageUrl');
      url = oktaLogoutUrl.replace('{redirectURL}', url);
    }

    await store.dispatch('mainModule/clearAll');
    await cacheService.clearAll();
    await storageService.cleanStorageAfterLogout();

    if (url) {
      url += '&afterCleanLocalStorage=true';
      Logger.info(`clearLocalStorageRedirectTo....${url}`);
      WindowUtils.setLocationHref(url);
    }
  }

  public async clearLocalStorageAndOKTALogout():Promise<void> {
    const requestInfo = WindowUtils.getRequestInfo();
    const plId = Number(requestInfo.paramInfo.paramValue.plId);
    const redirectURI = this.getLogoutRedirectUrl();
    Logger.info(`clearLocalStorageRedirectTo....${redirectURI}`);
    if (!!plId && !!redirectURI) {
      await oktaService.logout(plId, redirectURI);
    }
  }

  private getLogoutRedirectUrl(): string {
    const redirectToLogoutUrl = '?redirectToLogoutUrl=';
    const hash = window.location.hash;
    const index = hash.indexOf(redirectToLogoutUrl);
    return hash.substring(index + redirectToLogoutUrl.length);
  }
}

export const clearLocalStorageRedirectToLogoutService = new ClearLocalStorageRedirectToLogoutService();
